export default function roomCommonEventListener(room) {
  return store => {
    // core to ui
    room.addEventListeners({
      room_data_init: roomData => {
        store.commit('room/ROOM_INIT', roomData.data)
        store.commit('call/ROOM_INIT', roomData.data)
        room.emit({
          type: 'room_data_afterInit',
          roomData
        })
      },
      room_lms_data_init: data => {
        store.commit('room/ROOM_LMS_INIT', data.data);
      },
      room_disconnected: event => {
        store.commit('room/ROOM_DISCONNECTED', event.data);
      },
      room_reconnected: event => {
        store.commit('room/ROOM_RECONNECTED');
      },
      room_leaved: event => {
        store.commit('room/ROOM_LEAVED');
      },
      room_changeRoomMode: data => {
        store.commit('room/CHANGE_ROOM_MODE', data.data)
        store.commit('room/CLEAR_SCREEN_SHARE_STATUS', data.data)
        // store.commit('common/SET_ALERT_SMALL', { status: false }, { root: true })
      },
      room_user_enter: data => {
        if (data.data.roomUser.roomUserRole.roleId == 'obs') return ;

        store.commit('room/SET_ROOM_USER', data.data)
      },
      room_user_leave: data => {
        store.commit('room/REMOVE_ROOM_USER', data.data)
      },
      room_user_changeUserStatus: data => {
        store.commit('room/CHANGE_USER_STATUS', data.data)
      },
      room_changeUserDeviceStatus: data => {
        store.commit('room/CHANGE_ROOM_USER_DEVICE_STATUS', data.data)
      },
      room_changeUserDeviceStatusAll: data => {
        store.commit('room/CHANGE_ROOM_USER_DEVICE_STATUS_ALL', data.data)
      },
      room_changeUserRole: data => {
        store.commit('room/CHANGE_ROOM_USER_ROLE', data.data)
      },
      room_changeUserRoleAll: data => {
        store.commit('room/CHANGE_ROOM_USER_ROLE_ALL', data.data)
      },
      room_changeUserNickname: data => {
        store.commit('room/CHANGE_ROOM_USER_NICKNAME', data.data)
      },
      room_call_changeMixingLayout: data => {
        if(!data || !data.data) return

        store.commit('call/SET_ROOM_CALL_MIXING_LAYOUT', data.data);
        store.commit('call/SET_ROOM_CALL_VIDEO_LAYOUT', data.data.layoutType)
      },
      room_call_screenShare: e => {
        if(!e.data.userId){
          e.data.userId = e.data.targetUserId || e.userId;
        }
        store.commit('room/SET_ROOM_USER_SCREEN_SHARE', e.data)
      },
      room_schedule_state_change: data => {
        store.commit('room/CHANGE_ROOM_SCHEDULE_STATE', data.data)
      },
      room_changeUserRoleId: data => {
        store.commit('room/CHANGE_ROOM_USER_ROLE_ID', data.data)
      },
      room_user_setUserList: data => {
        const { roomUserList } = data.data
        store.commit('room/SET_ROOM_USER_LIST', roomUserList)
      },
      room_changeRoomTitle: data => {
        store.commit('room/CHANGE_ROOM_TITLE', data.data)
      },
      room_changeDefinePasswd: data => {
        store.commit('room/CHANGE_ROOM_DEFINE_PASSWD', data.data)
      },
      room_changeRoomInfo: data => {
        store.commit('room/CHANGE_ROOM_INFO', data.data)
      },
      room_cstudy_modifyCamStudy: e => {
        store.commit('room/CHANGE_ROOM_DEFAULT_DEVICE_STATUS', e.data)
        store.commit('room/CHANGE_ROOM_END_RESV_DATE', e.data)
        store.commit('room/SET_ROOM_PASSWORD', e.data)
        store.commit('room/SET_ROOM_LEVEL', e.data)
      }
    })
  }
}
